import { useMutation } from '@tanstack/react-query';
import { AxiosResponse } from 'axios';
import { decamelizeKeys } from 'humps';
import { USE_QUERY_CONSTANTS } from 'src/constants/constants';
import { ApiRoutes } from '../api/ApiRoutes';
import { useAxios } from '../api/AxiosContext';
import { CheckSeatsResponseProps } from '../api/response';

export const useCheckSeatMutation = () => {
  const axios = useAxios();

  const handleFetch = ({
    tripId,
    date,
    selectedSeats,
  }: {
    tripId: string;
    date: string;
    selectedSeats: { seatId: string; transitId: string }[];
  }) =>
    axios.post<AxiosResponse<CheckSeatsResponseProps[]>>(
      ApiRoutes.checkSeats.replace('{{trip_id}}', tripId),
      decamelizeKeys({ date, selectedSeats }),
    );

  return useMutation(['check-seats'], handleFetch, {
    cacheTime: USE_QUERY_CONSTANTS.cacheMs,
    retry: USE_QUERY_CONSTANTS.retry,
  });
};
